import React from 'react';
import { useIntl } from 'react-intl';
import { UniversalLink } from '@plone/volto/components';

const FooterSmallRight = () => {
  const intl = useIntl();
  return (
    <div className="footer-small-right">
      <UniversalLink href={'/' + intl.locale + '/credits'}>
        Credits
      </UniversalLink>
    </div>
  );
};

export default FooterSmallRight;
